var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SearchBannerFormItem",
    {
      staticClass: "form-item-date-calendar",
      attrs: {
        id: _vm.id,
        label: _vm.label,
        "drawer-config": _vm.drawerConfig,
        "display-value": _vm.displayValue,
        active: _vm.isActive,
        "is-desktop": _vm.isDesktop,
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: function ($event) {
          return _vm.$emit("close", $event)
        },
      },
    },
    [
      _vm.calendar
        ? _c(
            "div",
            {
              staticClass: "no-preference",
              on: { click: _vm.handleNoPreferenceClick },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("11414.App_HotelSearchDateButtonNoPreference")
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.calendar && !!_vm.calendar.dateShortcuts
        ? _c("ButtonTabs", {
            attrs: {
              buttons: _vm.calendar.dateShortcuts,
              "active-unique": _vm.calendar.activeShortcut,
              "scroll-into-view-on-mount": false,
            },
            on: { buttonClick: _vm.handleShortcutClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDateRange
        ? _c(
            "div",
            { attrs: { id: "range-placeholder-wrapper" } },
            [
              _c("DateRangePlaceholder", {
                attrs: { box: _vm.calendar.boxCheckinCheckout },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.calendar
        ? _c("SDCalendar", {
            attrs: { type: _vm.type, calendar: _vm.calendar },
            on: {
              update: _vm.handleCalendarUpdate,
              loadMore: _vm.handleCalendarLoadMore,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }